import { Box, Text } from '@factorialco/deprecated-design-system'
import type { TeamQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import type { ITeam } from 'modules/teams/store/models/Team'

import BlankState from './BlankState'
import Leader from './Leader'
import * as styles from './index.vanilla.css'

type TeamMembership = NonNullable<NonNullable<TeamQuery['teams']['team']>['memberships']>[number]

interface Props {
  team: ITeam
  readonly: boolean
  memberships: TeamMembership[]
  hasDevJobCatalogTree: boolean
}

const Leaders = ({ team, readonly, memberships, hasDevJobCatalogTree }: Props) => {
  const leaders = memberships.filter(
    (membership) => membership.lead && !membership.employee.terminatedOn
  )
  const hasLeaders = !!leaders.length
  return (
    <>
      <Box paddingBottom="s16">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t('teams.leaders.title')}
        </Text.Normal>
      </Box>
      {!hasLeaders && <BlankState team={team} readonly={readonly} />}
      {hasLeaders && (
        <Box flexDirection="row" flexWrap="wrap" justifyContent="spaceBetween">
          {leaders.map((leader) => (
            <Box className={styles.leader} key={leader.id}>
              <Leader
                canManageTeams={!readonly}
                membership={leader}
                hasDevJobCatalogTree={hasDevJobCatalogTree}
              />
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}

export default Leaders
